var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('el-result',{attrs:{"icon":"success","title":"支付成功","subTitle":"请点击按钮返回拍卖现场"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"danger","plain":"","size":"medium"},on:{"click":_vm.goConmodity}},[_vm._v("拍卖现场")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }